import { useEffect, useRef, useState } from 'react'
import { SDrawerOrModal, SGeneralForms } from 'shj-components'
import { Button, message, Radio, Spin } from 'antd'
import { useSetState } from 'ahooks'
import { startWork, verifyOuterData, startMerchOverflow } from '@/services/order'
import dayjs from 'dayjs'
import { getEnums } from '@/services/homeService.ts'
interface IProps {
  title: string
  orderId: string
  open: boolean
  detailsInfo: Record<string, any>
  setOpen: (open: boolean) => void
  fn: () => void
}
export default function SubmitWorkModal(prpos: IProps) {
  const formRef = useRef(null)
  const { open, title, setOpen, orderId, detailsInfo, fn } = prpos
  const [dictionaryData, setDictionaryData] = useState({})
  const [state, setState] = useSetState<any>({
    loading: false,
    errInfo: [],
    btnLoading: false,
  })

  useEffect(() => {
    console.log('open---->', open)
    if (open) {
      // 获取是否异常信息
      getOptions()
      /*verifyOuterData({
        params: {
          id: orderId,
        },
      })
        .then(res => {
          console.log('res---->', res)
          setState({ errInfo: res })
        })
        .finally(() => {
          setState({ loading: false })
        })*/
    }
  }, [open])

  const getOptions = async () => {
    try {
      const res: any = await Promise.allSettled([
        getEnums('plus-trade', 'com.shj.saas.plus.trade.enums.MerchTypeEnum'),
        getEnums('plus-product', 'com.shj.saas.plus.product.enums.DiscountSubcategoryTypeEnum'),
      ])
      const dataObj = {
        merchTypeEnum: res?.[0]?.value instanceof Array ? res?.[0]?.value : [],
        discountSubcategoryTypeEnum: res?.[1]?.value instanceof Array ? res?.[1]?.value : [],
      }
      console.log(res, dataObj)
      setDictionaryData(dataObj)
      // 初始化值
      onFormRef()?.setFieldsValue({
        discountSubcategoryType: dataObj.discountSubcategoryTypeEnum[0]?.key,
      })
    } catch (err) {
      console.log(err)
    }
  }

  const onFormRef = () => {
    const { onFormRef } = formRef.current || {}
    return onFormRef?.()
  }

  const onsubmit = () => {
    onFormRef()
      ?.validateFields()
      .then(values => {
        setState({ btnLoading: true })
        values.orderId = orderId
        values.productId = detailsInfo.productId
        startMerchOverflow(values)
          .then(res => {
            console.log(res)
            message.success('提交成功')
            fn?.()
            onCancel()
          })
          .finally(() => {
            setState({ btnLoading: false })
          })
      })
  }

  const onCancel = () => {
    onFormRef()?.resetFields()
    setOpen(false)
  }

  return (
    <SDrawerOrModal
      title={title}
      mode="modal"
      open={open}
      width={500}
      onCancel={onCancel}
      antdProps={{
        footer: (
          <div>
            <Button onClick={onCancel}>取消</Button>
            {/* disabled={state.errInfo.length} */}
            <Button
              style={{ marginLeft: 15 }}
              loading={state.btnLoading}
              type="primary"
              onClick={onsubmit}
            >
              提交
            </Button>
          </div>
        ),
      }}
    >
      {open && (
        <div>
          <Spin spinning={state.loading}>
            <div style={{}}>
              <p>
                提交后将发起审核工单，可在我发起的工单中查看审核进度，审核通过后，该订单商品优惠系数/可减项个数自动变化
              </p>
            </div>
            <div>
              <SGeneralForms
                ref={formRef}
                // httpOptionsFn={getOptions}
                initialValues={{ merchType: 'discount' }}
                layout={'vertical'}
                configs={[
                  {
                    formItem: [
                      {
                        spanCol: 24,
                        label: '申请类型',
                        name: 'merchType',
                        required: true,
                        children: (
                          <Radio.Group>
                            {dictionaryData['merchTypeEnum']?.map(item => (
                              <Radio key={item.key} value={item.key}>
                                {item.description}
                              </Radio>
                            ))}
                          </Radio.Group>
                        ),
                      },
                      {
                        spanCol: 24,
                        label: '优惠小类',
                        name: 'discountSubcategoryType',
                        required: true,
                        isDeps: true,
                        deps: form => form.getFieldValue('merchType') !== 'reduction',
                        children: (
                          <Radio.Group>
                            {dictionaryData['discountSubcategoryTypeEnum']?.map(item => (
                              <Radio key={item.key} value={item.key}>
                                {item.description}
                              </Radio>
                            ))}
                          </Radio.Group>
                        ),
                      },
                      {
                        label: '申请比例',
                        name: 'applyInfo',
                        spanCol: 24,
                        required: true,
                        isDeps: true,
                        deps: form => form.getFieldValue('merchType') !== 'reduction',
                        type: 'inputNumber',
                        rules: [{ required: true, message: '请输入0~1的小数' }],
                        comConfig: {
                          min: 0,
                          max: 1,
                          precision: 4,
                        },
                      },
                      {
                        label: '申请减项个数',
                        name: 'applyInfo',
                        spanCol: 24,
                        required: true,
                        isDeps: true,
                        deps: form => form.getFieldValue('merchType') === 'reduction',
                        type: 'inputNumber',
                        rules: [{ required: true, message: '请输入' }],
                        comConfig: {
                          min: 1,
                          precision: 0,
                          max:9999.9999,
                        },
                      },
                      {
                        spanCol: 24,
                        label: '',
                        isDeps: true,
                        deps: form => form.getFieldValue('merchType') === 'reduction',
                        children: () => {
                          return (
                            <p style={{ marginTop: '-20px', marginLeft: 5, color: '#a9a9a9' }}>
                              输入正整数，输入值为允许减项的总项数
                            </p>
                          )
                        },
                      },
                      {
                        spanCol: 24,
                        label: '备注',
                        name: 'remark',
                        type: 'textarea',
                        comConfig: {
                          maxLength: 255,
                          showCount: true
                        }
                      }
                    ],
                  },
                ]}
              />
            </div>
          </Spin>
        </div>
      )}
    </SDrawerOrModal>
  )
}
